import { memo, useCallback, useEffect, useMemo, useState } from "react"
import Money from "../../../../helpers/utils/money/money";
import Button from "../../../bootstrap/Button";
import FormGroup from "../../../bootstrap/forms/FormGroup";
import Input from "../../../bootstrap/forms/Input";
import Modal, { ModalBody, ModalHeader, ModalTitle } from "../../../bootstrap/Modal";
import Icon from "../../../icon/Icon";
import ListSubCategoryItemsModal from '../../Categories/ListSubCategoryItems'
import { getMenuProductId, isMenuProductActive } from "../../../../helpers/utils/menuProductStatus";

function ProductItem({product, active, onToggleProductStatus}) {
  const onToggleStatus = useCallback(() => {
    if (onToggleProductStatus) onToggleProductStatus(product.id);
  }, [onToggleProductStatus, product.id])

  return(
    <div className='row g-4 py-2'>
      <div className='col-md-1'>
        <img
          src={product.image_url}
          alt='Imagem'
          width={40}
          height={40}
        />
      </div>
      <div className='col-md-5'>
        <FormGroup>
          <Input value={product.name} disabled readOnly />
        </FormGroup>
      </div>
      <div className='col-md-2'>
        <FormGroup>
          <Input
            value={Money.centsToCoin(product.price).toFixed(2)}
            readOnly
          />
        </FormGroup>
      </div>
      <div className='col-md-2'>
        <FormGroup>
          <Input
            value={Money.centsToCoin(product.discount).toFixed(2)}
            readOnly
          />
        </FormGroup>
      </div>
      <div className='col-md-2'>
        <Button
          isLink
          color={active ? 'success' : 'danger'}
          icon='Circle'
          onClick={onToggleStatus}
          className='text-nowrap'
        >
          {active ? 'Ativo' : 'Inativo'}
        </Button>
      </div>
    </div>
  );
}

function SubCategoryItem({category, showSubCategory}) {
  
  const onShowSubCategory = useCallback(() => showSubCategory(category),[category])

  return(
    <div className='row g-4 py-2'>
      <div className='col-md-1'>
        <img
          src={category.image_url}
          alt='Imagem'
          width={40}
          height={40}
        />
      </div>
      <div className='col-md-10'>
        <FormGroup>
          <Input value={category.name} disabled readOnly />
        </FormGroup>
      </div>
      <div className='col-md-1'>
        <a href='#' onClick={onShowSubCategory}>
          <Icon
            style={{ marginTop: 5 }}
            icon='RemoveRedEye'
            size='2x'// null || 'sm' || 'md' || 'lg' || '2x' || '3x' || '4x' || '5x' || '6x' || '7x' || '8x' || '9x' || '10x'
          />
        </a>
      </div>
    </div>
  );
}

const ProductElement = memo(ProductItem);

function ListCategoryItemsModal({
  open,
  onClose,
  products,
  subCategories,
  category,
  productStatus,
  onToggleProductStatus,
  onChangeShowSubCategory,
}) {

  const [productsRender, setproductsRender] = useState([])
  const [subCategoriesRender, setsubCategoriesRender] = useState([])
  const [subcategoryShow, setsubcategoryShow] = useState(null)
  const [showSubCategoryModal, setshowSubCategoryModal] = useState(false)
  const [productSearch, setProductSearch] = useState('')

  useEffect(() => {
    if(category) {
      function mountProductsRender() {
        const productsInCategory = category.products || [];

        const productsRender = [];
        productsInCategory.forEach(product => {
          const productId = getMenuProductId(product);
          const pFind = products.find(p => p.id === productId);
          if(pFind) {
            productsRender.push({
              id: pFind.id,
              name: pFind.name,
              image_url: pFind.image_url,
              price: pFind.price,
              discount: pFind.discount,
            })
          }
        })

        setproductsRender(productsRender)
      }
      function mountSubCategoriesRender() {
        const subCategoryInCategory = category.subCategories || [];

        const subCategoriesRender = [];
        subCategoryInCategory.forEach(id => {
          const subCatFind = subCategories.find(subCat => subCat.id === id);
          if(subCatFind) {
            subCategoriesRender.push(subCatFind)
          }
        })

        setsubCategoriesRender(subCategoriesRender)
      }

      mountProductsRender();
      mountSubCategoriesRender();
    }
  },[products, category, subCategories])

  useEffect(() => {
    setProductSearch('');
  }, [category?.id])

  const onShowSubCategory = useCallback((category) => {
    setsubcategoryShow(category)
    onChangeShowSubCategory(true)
    setshowSubCategoryModal(true)
  },[onChangeShowSubCategory])

  const onCloseSubCategory = useCallback(() => {
    onChangeShowSubCategory(false)
    setshowSubCategoryModal(false)
  },[onChangeShowSubCategory])

  const HeaderSubCategories = useMemo(() => (
    <div className='row g-4 py-2'>
      <div className='col-md-1'>
        <p>Imagem</p>
      </div>
      <div className='col-md-10'>
        <p>Nome</p>
      </div>
    </div>
  ), [])

  const Header = useMemo(() => (
    <div className='row g-4 py-2'>
      <div className='col-md-1'>
        <p>Imagem</p>
      </div>
      <div className='col-md-5'>
        <p>Nome</p>
      </div>
      <div className='col-md-2'>
        <p>Preço</p>
      </div>
      <div className='col-md-2'>
        <p>Desconto</p>
      </div>
      <div className='col-md-2'>
        <p>Status no cardápio</p>
      </div>
    </div>
  ), [])

  const filteredProducts = useMemo(() => {
    const search = productSearch.trim().toLowerCase();
    if (!search) return productsRender;

    return productsRender.filter((product) =>
      product.name?.toLowerCase().includes(search)
    );
  }, [productsRender, productSearch])

  return(
    <>
    <Modal
      id={'modal-category-items'}
      titleId={'Items da Sub-categoria'}
      isOpen={open}
      setIsOpen={onClose}
      isStaticBackdrop={true}
      isScrollable={false}
      isCentered={true}
      size="lg" // 'sm' || 'lg' || 'xl' 
      isAnimation={true}
    >
      <ModalHeader 
        style={showSubCategoryModal ? { opacity: 0.1, backgroundColor: 'black' } : {}}
        setIsOpen={onClose}
      >
        <ModalTitle id="register-category">{category?.name}</ModalTitle>
      </ModalHeader>
      <ModalBody style={showSubCategoryModal ? { opacity: 0.1, backgroundColor: 'black' } : {}}>
        <div className='row g-4 mt-1'>
          <h5>Sub-Categorias</h5>
        </div>

        { HeaderSubCategories }

        {subCategoriesRender.map((item, index) => (
          <SubCategoryItem
            key={'catLiSubCat' + index}
            category={item}
            showSubCategory={onShowSubCategory}
          />
        ))}

        <div className='row g-4 mt-1'>
          <h5>Produtos</h5>
        </div>

        <div className='row g-4 py-2'>
          <FormGroup className='col-md-12'>
            <Input
              value={productSearch}
              onChange={(event) => setProductSearch(event.target.value)}
              placeholder='Buscar produto'
            />
          </FormGroup>
        </div>

        { Header }

        {filteredProducts.map((product, index) => (
          <ProductElement
            key={'prodLi' + index}
            product={product}
            active={isMenuProductActive(productStatus, product.id)}
            onToggleProductStatus={onToggleProductStatus}
          />
        ))}

        {filteredProducts.length === 0 && (
          <div className='text-center text-muted py-3'>
            Nenhum produto encontrado
          </div>
        )}

        {/* Buttons */}
        <div className="d-flex flex-row-reverse" style={{ marginTop: 10 }}>
          <Button
            color="danger"
            icon="cancel"
            rounded={1}
            onClick={onClose}
            shadow="sm"
            hoverShadow="sm"
            size="sm"
          >
            Fechar
          </Button>
        </div>
      </ModalBody>
    </Modal>

    <ListSubCategoryItemsModal
      open={showSubCategoryModal}
      onClose={onCloseSubCategory}
      products={products}
      category={subcategoryShow}
      productStatus={productStatus}
      onToggleProductStatus={onToggleProductStatus}
    />
    </>
  );
}

export default memo(ListCategoryItemsModal);
